// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteContentStyles } from "@steiner/Overrides/Widgets/Header/AutocompleteContent";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

autocompleteContentStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

autocompleteContentStyles.headerText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

autocompleteContentStyles.resultsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    `,
};

autocompleteContentStyles.link = {
    color: "common.ui6",
    typographyProps: {
        size: "12px",
        lineHeight: "15px",
        weight: fontConfig.weight.regular,
        css: css`
            ${ellipsis(1)}
            word-break: break-all;
            overflow-wrap: break-word;
        `,
    },
    css: css`
        align-self: baseline;
    `,
};
